'use client';

import { I18nextProvider } from 'react-i18next';
import { ReactNode } from 'react';
import { Resource, createInstance } from 'i18next';
import initTranslations from '../i18n';
import { LocaleProvider } from '@/components/providers/context/locale-context';

export default function TranslationsProvider({
    children,
    locale,
    namespaces,
    resources,
}: Readonly<{
    children: ReactNode;
    locale: string;
    namespaces: string[];
    resources: Resource;
}>) {
    const i18n = createInstance();

    initTranslations(locale, namespaces, i18n, resources);

    return (
        <LocaleProvider locale={locale}>
            <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
        </LocaleProvider>
    );
}
